<script>
import { pcTextArr } from 'element-china-area-data'
import { regionDetail, updateRegion } from '@/api/admin'
export default {
  name: 'AdminRegion',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      detailLoading: false,
      loading: false,
      id: 0,
      pcTextArr,
      data: {
        region: ''
      },
      props: { multiple: true }
    }
  },
  watch: {
    item: {
      handler(val, oldVal) {
        if (this.item.dialogVisible === true) {
          this.id = val.id
          this.handleDetail()
        }
      },
      deep: true
    }
  },
  created() {
    this.id = this.item.id
    this.handleDetail()
  },
  methods: {
    async handleDetail() {
      const res = await regionDetail(this.id)
      this.data.region = res.data
    },
    submit() {
      const that = this
      updateRegion({
        userId: this.id,
        region: this.data.region
      }).then(res => {
        this.$message({
          message: '设置区域权限成功',
          type: 'success',
          duration: 1000,
          onClose() {
            if (that.$refs.form !== undefined) {
              that.$refs.form.resetFields()
            }
            that.item.dialogVisible = false
          }
        })
      })
    }
  }
}
</script>

<template>
  <el-form ref="form" v-loading="detailLoading" :model="data" label-width="100px">
    <el-form-item label="区域选择" prop="region">
      <el-cascader
        v-model="data.region"
        :options="pcTextArr"
        :props="props"
        clearable
      />
    </el-form-item>

    <el-form-item>
      <el-button type="primary" :loading="loading" @click="submit">{{ $t('common.save') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<style scoped>

</style>
